import { UPDATE_PARAMS } from '../constants';

export function updateParams(params) {
  return {
    type: UPDATE_PARAMS,
    params
  };
}
